var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";
var Bridge = /** @class */ (function (_super) {
    __extends(Bridge, _super);
    function Bridge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Bridge.validate = function (item, odontogram, items) {
        // validate teeth selected
        if (!ItemValidators.hasTeethSelected(item)) {
            return false;
        }
        return true;
    };
    Bridge.apply = function (odontogram, item) {
        var resolvedConditions = [
            "wear",
            "caries",
            "restoration",
            "veneer",
            "crown",
            "onlay",
            "denture",
            "bridge",
            "adhesive-bridge",
            "severely-damaged",
        ];
        var mesialTeeth = [];
        var distalTeeth = [];
        var upperArch = Array.apply(null, Array(16));
        upperArch = upperArch.map(function (val, i) {
            var number = i < 8 ? 18 - i : i + 13;
            return {
                number: number,
                applied: item.teeth.includes(number),
            };
        });
        var lowerArch = Array.apply(null, Array(16));
        lowerArch = lowerArch.map(function (val, i) {
            var number = i < 8 ? 48 - i : i + 23;
            return {
                number: number,
                applied: item.teeth.includes(number),
            };
        });
        upperArch.forEach(function (tooth, i) {
            if (tooth.applied) {
                if (i > 0 && upperArch[i - 1].applied) {
                    if (i <= 7) {
                        distalTeeth.push(tooth.number);
                    }
                    else {
                        mesialTeeth.push(tooth.number);
                    }
                }
                if (i < 15 && upperArch[i + 1].applied) {
                    if (i <= 7) {
                        mesialTeeth.push(tooth.number);
                    }
                    else {
                        distalTeeth.push(tooth.number);
                    }
                }
            }
        });
        lowerArch.forEach(function (tooth, i) {
            if (tooth.applied) {
                if (i > 0 && lowerArch[i - 1].applied) {
                    if (i <= 7) {
                        distalTeeth.push(tooth.number);
                    }
                    else {
                        mesialTeeth.push(tooth.number);
                    }
                }
                if (i < 15 && lowerArch[i + 1].applied) {
                    if (i <= 7) {
                        mesialTeeth.push(tooth.number);
                    }
                    else {
                        distalTeeth.push(tooth.number);
                    }
                }
            }
        });
        odontogram
            .filter(function (tooth) { return item.teeth.indexOf(tooth.number) > -1; })
            .forEach(function (tooth, i) {
            tooth.diagnosis = tooth.diagnosis
                .filter(function (diagnosis) { return !resolvedConditions.includes(diagnosis.condition); })
                .filter(function (diagnosis) {
                return !(diagnosis.condition === "fracture" &&
                    diagnosis.options.includes("crown"));
            });
            tooth.plan.push({ treatment: item.treatment });
            if (mesialTeeth.includes(tooth.number)) {
                tooth.plan.push({ treatment: item.treatment, options: "mesial" });
            }
            if (distalTeeth.includes(tooth.number)) {
                tooth.plan.push({ treatment: item.treatment, options: "distal" });
            }
        });
        return odontogram;
    };
    Bridge.getIdentifier = function () {
        return "bridge";
    };
    return Bridge;
}(AbstractTreatment));
export { Bridge };



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/prostho/bridge.ts.pre-build-optimizer.js